// Heuristic guess of "deep history" so we can offer a pre-flight estimate
// before we know the true cursor depth. Tunable, intentionally generous.
export const HEURISTIC_TOTAL: Record<string, number> = {
  'app.bsky.feed.post': 5000,
  'app.bsky.feed.repost': 2000,
  'app.bsky.feed.like': 20000,
  'app.bsky.graph.follow': 5000,
  'app.bsky.graph.block': 200,
}

export type ProgressSample = {
  records: number
  ms: number
}

export function estimateRemainingMs(
  samples: ProgressSample[],
  fetched: number,
  guessTotal: number,
): number | null {
  if (samples.length === 0) return null
  const totalRecords = samples.reduce((a, s) => a + s.records, 0)
  const totalMs = samples.reduce((a, s) => a + s.ms, 0)
  if (totalRecords === 0 || totalMs === 0) return null
  const msPerRecord = totalMs / totalRecords
  const remaining = Math.max(0, guessTotal - fetched)
  return remaining * msPerRecord
}

export function rateRecordsPerSec(samples: ProgressSample[]): number {
  const r = samples.reduce((a, s) => a + s.records, 0)
  const m = samples.reduce((a, s) => a + s.ms, 0)
  if (m === 0) return 0
  return (r / m) * 1000
}
